export var ButtonSizeTypes;

(function (ButtonSizeTypes) {
  ButtonSizeTypes["Default"] = "Default";
  ButtonSizeTypes["Large"] = "Large";
  ButtonSizeTypes["Small"] = "Small";
})(ButtonSizeTypes || (ButtonSizeTypes = {}));